import { render } from "./App.vue?vue&type=template&id=802f5fb8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/tailwind.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Projects\\vue.js-3\\service-provider-project\\service-provider\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__